import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FundPicker } from "@/components/FundPicker";
import { TYPES } from "@/components/compare/config";

export const ItemPicker = ({ type, pool, ids, onPick, compact }) => {
  const t = TYPES[type];
  if (t.fund) return <FundPicker kind={type === "index" ? "index" : "mf"} onPick={onPick} exclude={ids} compact={compact} />;
  const avail = pool.filter((x) => !ids.includes(x.id));
  return (
    <div>
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Choose a {t.noun}</p>
      <Select value="" onValueChange={(id) => onPick(id)}>
        <SelectTrigger data-testid="compare-item-select" className="h-12 rounded-xl bg-white"><SelectValue placeholder={`Select from ${avail.length} ${t.noun}s`} /></SelectTrigger>
        <SelectContent className="max-h-80">
          {avail.map((x) => <SelectItem key={x.id} value={x.id} data-testid={`compare-option-${x.id}`}><span className="font-semibold">{x.name}</span> <span className="text-xs text-slate-500">· {t.sub(x)}</span></SelectItem>)}
        </SelectContent>
      </Select>
      {!compact && (
        <div className="mt-3 flex flex-wrap gap-2">
          {avail.slice(0, 8).map((x) => <button key={x.id} data-testid={`compare-chip-${x.id}`} onClick={() => onPick(x.id)} className="rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold hover:border-[#10B981] hover:text-[#059669] transition-colors">+ {x.name}</button>)}
        </div>
      )}
    </div>
  );
};
